/**
 * Force Index
 *
 * Alexander Elder's oscillator measuring buying/selling pressure.
 * Force = Close change × Volume, then smoothed with EMA.
 *
 * Category: Momentum | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { computeEMA } from "./sma";

export const forceIndexIndicator: IndicatorDefinition = {
  id: "forceindex",
  name: "Force Index",
  shortName: "FI",
  category: "momentum",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 13, min: 1, max: 200 },
    { key: "color", label: "Color", type: "color", default: "#FF5722" },
  ],
  plots: [
    { key: "fi", label: "FI", color: "#FF5722", style: "line", lineWidth: 2, priceScaleId: "fi" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const data: { time: number; value: number }[] = [];

    if (candles.length < 2) return [{ key: "fi", data }];

    const raw: number[] = [0];
    for (let i = 1; i < candles.length; i++) {
      raw.push((candles[i].close - candles[i - 1].close) * (candles[i].volume || 0));
    }

    const ema = computeEMA(raw, period);
    for (let i = 0; i < ema.length; i++) {
      if (!isNaN(ema[i])) {
        data.push({ time: candles[i].time, value: ema[i] });
      }
    }

    return [{ key: "fi", data }];
  },
};
